<template>
  <div>
    Shapefile/GeoJSON/WKT Requirements:
    <ul class="mt-2">
      <li>
        AOI geometry type can only be <i>Polygon</i> or <i>MultiPolygon</i>
      </li>
      <li>We don't support files with multiple shapefiles</li>
      <li class="server">
        AOI edge lengths must be greater than
        {{ Number(250).toLocaleString() }}
        meters
      </li>
    </ul>
    <div class="mt-4">
      <span class="info--text">• </span>requirement is checked on the server
      when you create your selection or place an order
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({});
</script>

<style lang="scss" scoped>
ul {
  list-style: none; /* Remove default bullets */
  padding: 0;
  margin: 0;
}

li {
  padding-left: 1em;
  text-indent: -0.7em;
}

li::before {
  content: "• ";
}

li.server::before {
  color: #2196f3;
}
</style>
